import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import type { GetReleaseGroupAddableProjectsResponse } from '../../../../shared/types/routes/teams';

/**
 * Generate the query key for finding addable members for a team.
 */
export const getReleaseGroupAddableProjectsQueryKey = (
  teamId: number,
  releaseGroupId: number,
): QueryKey => ['teams', teamId, 'release-groups', releaseGroupId, 'addable-projects'];

/**
 * Fetch the addable Projects + RGs for a team.
 */
export function fetchReleaseGroupAddableProjects(
  teamId: number,
  releaseGroupId: number,
) {
  return get<GetReleaseGroupAddableProjectsResponse>(
    `/api/teams/${teamId}/release-groups/${releaseGroupId}/addable-projects`,
    false,
  );
}

/**
 * Helper hook for fetching the matches of a given component in a user's revision.
 * @param teamId - The ID of the team to fetch addable members for.
 * @param releaseGroupId - The ID of the release group to fetch addable projects for.
 * @returns An infinite query for the addable members of the given team.
 */
export default function useReleaseGroupAddableProjects(
  teamId: number,
  releaseGroupId: number,
) {
  return useQuery<GetReleaseGroupAddableProjectsResponse>({
    queryKey: getReleaseGroupAddableProjectsQueryKey(teamId, releaseGroupId),
    queryFn: () => fetchReleaseGroupAddableProjects(teamId, releaseGroupId),
  });
}
